import React from "react";

export const RegistrationSuccessPromo = () => (
  <svg
    width="214"
    height="212"
    viewBox="0 0 214 212"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M157.278 130C156.939 130 156.614 129.864 156.374 129.622C156.135 129.38 156 129.052 156 128.71V72.2902C156 71.948 156.135 71.6198 156.374 71.3779C156.614 71.1359 156.939 71 157.278 71H210.722C210.923 71 211.121 71.0477 211.3 71.1392C211.479 71.2308 211.634 71.3636 211.752 71.5269C211.871 71.6902 211.95 71.8794 211.983 72.0793C212.016 72.2792 212.001 72.484 211.941 72.6772L203.267 100.501L211.941 128.318C212.001 128.511 212.016 128.716 211.983 128.916C211.95 129.115 211.871 129.305 211.752 129.468C211.634 129.631 211.479 129.764 211.3 129.856C211.121 129.947 210.923 129.995 210.722 129.995L157.278 130Z"
      fill="#38AB4F"
    />
    <path
      d="M211.425 72.5979L202.563 101.001L211.425 129.402H157.575V72.5979H211.425ZM211.425 70H157.575C156.892 70 156.237 70.2737 155.754 70.7609C155.271 71.2481 155 71.9089 155 72.5979V129.402C155 130.091 155.271 130.752 155.754 131.239C156.237 131.726 156.892 132 157.575 132H211.425C211.829 132 212.228 131.904 212.588 131.72C212.949 131.535 213.262 131.268 213.501 130.939C213.74 130.61 213.899 130.229 213.965 129.827C214.031 129.424 214.003 129.012 213.881 128.623L205.262 101.001L213.881 73.3773C214.003 72.9882 214.031 72.5757 213.965 72.1733C213.899 71.7709 213.74 71.3898 213.501 71.0609C213.262 70.7321 212.949 70.4646 212.588 70.2803C212.228 70.096 211.829 70 211.425 70Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.28054 130C2.07989 130 1.88206 129.952 1.70306 129.861C1.52406 129.769 1.36889 129.636 1.25018 129.473C1.13147 129.31 1.05254 129.121 1.01974 128.921C0.986946 128.721 1.00123 128.516 1.06142 128.323L9.74856 100.501L1.05887 72.6772C0.998672 72.484 0.984387 72.2792 1.01719 72.0793C1.04998 71.8794 1.12897 71.6902 1.24768 71.5269C1.36639 71.3636 1.5215 71.2308 1.7005 71.1392C1.8795 71.0477 2.07733 71 2.27798 71H55.7221C56.061 71 56.3861 71.1359 56.6257 71.3779C56.8654 71.6198 57 71.948 57 72.2902V128.71C57 129.052 56.8654 129.38 56.6257 129.622C56.3861 129.864 56.061 130 55.7221 130H2.28054Z"
      fill="#38AB4F"
    />
    <path
      d="M56.4248 72.5979V129.402H2.57535L11.4391 101.001L2.57535 72.5979H56.4248ZM56.4248 70H2.57535C2.17101 70 1.77234 70.096 1.41162 70.2803C1.05091 70.4646 0.738278 70.7321 0.499056 71.0609C0.259833 71.3898 0.100724 71.7709 0.0346312 72.1733C-0.0314619 72.5757 -0.0026767 72.9882 0.118626 73.3773L8.73773 101.001L0.118626 128.623C-0.0026767 129.012 -0.0314619 129.424 0.0346312 129.827C0.100724 130.229 0.259833 130.61 0.499056 130.939C0.738278 131.268 1.05091 131.535 1.41162 131.72C1.77234 131.904 2.17101 132 2.57535 132H56.4248C57.1078 132 57.7629 131.726 58.2458 131.239C58.7287 130.752 59 130.091 59 129.402V72.5979C59 71.9089 58.7287 71.2481 58.2458 70.7609C57.7629 70.2737 57.1078 70 56.4248 70Z"
      fill="white"
    />
    <path
      d="M107.987 183C107.202 183.002 106.421 182.877 105.675 182.63L27.0191 156.524C25.5595 156.042 24.2887 155.111 23.3877 153.865C22.4866 152.618 22.001 151.118 22 149.579V34.436C21.9982 32.8945 22.4824 31.3917 23.3836 30.142C24.2849 28.8922 25.5572 27.9593 27.0191 27.4761L105.699 1.37032C107.194 0.876559 108.808 0.876559 110.304 1.37032L188.983 27.4761C190.445 27.9597 191.717 28.8929 192.617 30.1426C193.518 31.3923 194.002 32.8948 194 34.436V149.567C193.999 151.105 193.514 152.604 192.613 153.851C191.713 155.098 190.443 156.029 188.983 156.511L110.304 182.617C109.557 182.868 108.775 182.998 107.987 183Z"
      fill="#246F33"
    />
    <path
      d="M112.043 183C111.258 183.002 110.478 182.877 109.733 182.63L107.013 156.524C105.554 156.042 102.287 155.111 101.387 153.865C100.486 152.618 100.001 151.118 100 149.579V34.436C99.9982 32.8945 100.482 31.3917 101.383 30.142C102.283 28.8922 103.555 27.9593 105.016 27.4761L107.736 1.37032C109.23 0.876559 110.867 0.876559 112.361 1.37032L190.987 27.4761C192.447 27.9597 193.718 28.8929 194.618 30.1426C195.518 31.3923 196.002 32.8948 196 34.436V149.567C195.999 151.105 195.514 152.604 194.614 153.851C193.714 155.098 192.445 156.029 190.987 156.511L114.358 182.617C113.612 182.868 112.83 182.998 112.043 183Z"
      fill="#2D873F"
    />
    <path
      d="M108.499 2.57799C109.145 2.57704 109.788 2.68062 110.401 2.88475L189.267 29.0513C190.475 29.4514 191.526 30.2227 192.27 31.2552C193.015 32.2878 193.415 33.5292 193.415 34.8028V150.201C193.415 151.474 193.015 152.715 192.27 153.747C191.525 154.78 190.475 155.55 189.267 155.95L110.401 182.117C109.166 182.526 107.832 182.526 106.596 182.117L27.7303 155.95C26.5229 155.55 25.4721 154.78 24.7274 153.747C23.9827 152.715 23.5821 151.474 23.5824 150.201V34.8028C23.5819 33.5292 23.9825 32.2878 24.7272 31.2552C25.4718 30.2227 26.5227 29.4514 27.7303 29.0513L106.596 2.88475C107.21 2.68084 107.852 2.57727 108.499 2.57799ZM108.499 2.33173e-06C107.577 -0.000677473 106.662 0.147293 105.788 0.438247L26.9218 26.6048C25.1981 27.1724 23.6974 28.2707 22.634 29.7428C21.5706 31.215 20.9987 32.9859 21 34.8028V150.201C20.9991 152.018 21.5711 153.789 22.6345 155.261C23.6979 156.733 25.1983 157.831 26.9218 158.399L105.785 184.563C107.547 185.146 109.45 185.146 111.212 184.563L190.078 158.397C191.802 157.829 193.302 156.73 194.366 155.258C195.429 153.786 196.001 152.015 196 150.199V34.8028C196.001 32.9859 195.429 31.215 194.366 29.7428C193.303 28.2707 191.802 27.1724 190.078 26.6048L111.212 0.438247C110.337 0.1475 109.421 -0.000461143 108.499 2.33173e-06Z"
      fill="white"
    />
    <path
      d="M108 173C107.293 173 106.591 172.887 105.92 172.665L36.5327 149.614C35.2126 149.177 34.0636 148.334 33.2497 147.205C32.4358 146.075 31.9984 144.717 32 143.323V41.6664C31.999 40.2735 32.4363 38.9157 33.2496 37.7863C34.063 36.657 35.2109 35.8135 36.5301 35.376L105.92 12.338C107.27 11.8873 108.73 11.8873 110.08 12.338L179.47 35.3863C180.79 35.8231 181.938 36.6664 182.751 37.7959C183.565 38.9255 184.002 40.2836 184 41.6767V143.334C184.002 144.727 183.565 146.085 182.752 147.215C181.938 148.344 180.79 149.187 179.47 149.624L110.08 172.672C109.409 172.893 108.706 173.004 108 173Z"
      fill="#38AB4F"
    />
    <path
      d="M108.078 173C107.372 173 113.401 93.7243 112.731 93.5022C113.544 94.6318 111.412 93.0658 112.731 93.5022C112.729 94.8956 111.918 92.3727 112.731 93.5022L106 12.338C107.349 11.8873 108.807 11.8873 110.155 12.338L179.474 35.3863C180.793 35.8231 181.94 36.6664 182.753 37.7959C183.565 38.9255 184.002 40.2836 184 41.6766V143.334C184.002 144.727 183.566 146.085 182.753 147.215C181.94 148.344 180.793 149.187 179.474 149.624L110.155 172.672C109.485 172.893 108.783 173.004 108.078 173Z"
      fill="#329A47"
    />
    <path
      d="M107.995 13.5708C108.562 13.5666 109.125 13.6533 109.664 13.8279L178.804 36.793C179.862 37.1452 180.783 37.8225 181.435 38.7289C182.087 39.6352 182.438 40.7245 182.438 41.8421V143.132C182.438 144.25 182.087 145.339 181.435 146.245C180.783 147.152 179.862 147.829 178.804 148.181L109.664 171.146C108.582 171.506 107.413 171.506 106.33 171.146L37.191 148.181C36.1324 147.83 35.2113 147.152 34.5585 146.246C33.9057 145.34 33.5543 144.25 33.5544 143.132V41.8421C33.5543 40.7242 33.9057 39.6347 34.5585 38.7283C35.2113 37.8219 36.1324 37.1448 37.191 36.793L106.33 13.8279C106.869 13.6534 107.432 13.5666 107.997 13.5708H107.995ZM107.997 11C107.156 11.0005 106.321 11.136 105.523 11.4011L36.3857 34.3661C34.8161 34.8876 33.4507 35.8922 32.4837 37.2368C31.5167 38.5813 30.9975 40.1974 31 41.8549V143.145C30.9971 144.803 31.5162 146.419 32.4832 147.764C33.4503 149.108 34.8159 150.113 36.3857 150.634L105.525 173.599C107.132 174.134 108.868 174.134 110.475 173.599L179.614 150.634C181.184 150.113 182.55 149.108 183.517 147.764C184.484 146.419 185.003 144.803 185 143.145V41.8549C185.002 40.1974 184.483 38.5813 183.516 37.2368C182.549 35.8922 181.184 34.8876 179.614 34.3661L110.475 11.4011C109.677 11.1358 108.841 11.0004 108 11H107.997Z"
      fill="white"
    />
    <g filter="url(#filter0_f)">
      <ellipse
        cx="107"
        cy="205"
        rx="51"
        ry="3"
        fill="black"
        fillOpacity="0.6"
      />
    </g>
    <g filter="url(#filter1_d)">
      <path
        d="M109.042 49.2637H142.74C146.606 49.2637 149.74 52.3977 149.74 56.2637V89.9614C149.74 91.9097 148.928 93.7698 147.499 95.0944L104.579 134.891C101.82 137.45 97.531 137.369 94.87 134.708L64.2956 104.133C61.6346 101.472 61.5537 97.1835 64.1124 94.424L103.909 51.5042C105.233 50.0756 107.094 49.2637 109.042 49.2637Z"
        fill="white"
        fillOpacity="0.2"
      />
      <path
        d="M92 86L106 100L134 72M142.74 49.2637H109.042C107.094 49.2637 105.233 50.0756 103.909 51.5042L64.1124 94.424C61.5537 97.1835 61.6346 101.472 64.2956 104.133L94.87 134.708C97.531 137.369 101.82 137.45 104.579 134.891L147.499 95.0944C148.928 93.7698 149.74 91.9097 149.74 89.9614V56.2637C149.74 52.3977 146.606 49.2637 142.74 49.2637Z"
        stroke="white"
        strokeWidth="5"
        strokeLinejoin="round"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M149 98L105.871 138.887C102.74 141.783 97.8747 141.691 94.8557 138.68L68 110.5L94.8557 134.548L96.1392 135.589C98.4682 137.912 102.222 137.983 104.637 135.749L129.215 114.631L149 98Z"
      fill="#ECEDEE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M136 74L108.022 102.261C107.554 102.734 106.918 103 106.256 103C105.593 103 104.958 102.734 104.489 102.261L91 88.1305L104.964 98.7509C105.717 99.3235 106.768 99.2903 107.483 98.6715L136 74Z"
      fill="#ECEDEE"
    />
    <defs>
      <filter
        id="filter0_f"
        x="52"
        y="198"
        width="110"
        height="14"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="filter1_d"
        x="46"
        y="35"
        width="120"
        height="120"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0666667 0 0 0 0 0.168627 0 0 0 0 0.266667 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
